import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import Layout from "../../components/layout/Layout";
import { MdFileDownload } from "react-icons/md";
import UserIcon from "../../assets/icons/user-edit.png";
import { CloseSquare } from "iconsax-react";
import { Form, Formik, Field } from "formik";
import { useUserLogic } from "./useUserLogic";
import { v4 } from "uuid";
import useRolesLogic from "./Roles/useRolesLogic";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material";
function Users() {
  const [showAddUserCard, setShowAddUserCard] = useState(false);

  function toggleUserCardModal() {
    setShowAddUserCard((prev) => !prev);
  }

  const {
    adminUserList,
    filters,
    handleSearchTerm,
    handleDownloadAdminUsers,
    handleDelete,
    handlePagination,
  } = useUserLogic();
  console.log({ adminUserList });
  return (
    <Layout pageName="Users">
      <section className="mt-6">
        <AddUserCard open={showAddUserCard} handleClose={toggleUserCardModal} />
        <div className=" flex justify-between items-center mt-2">
          <div className="join border border-[#CDD0D7] p-1  tabs tabs-bordered max-w-max">
            <input
              type="radio"
              name="my_tabs_1"
              role="tab"
              className="tab join-item underline font-semibold"
              aria-label="Users"
            />
            {/* <input
              type="radio"
              name="my_tabs_1"
              role="tab"
              className="tab join-item"
              aria-label="Invite"
            /> */}
          </div>
          <button
            className="btn bg-[#071839] text-white px-12"
            onClick={toggleUserCardModal}
          >
            Add User
          </button>
        </div>

        <div className="bg-white rounded-md p-3 mt-3">
          <div className="card  bg-white  rounded ">
            <div className="flex items-center justify-between">
              <h4 className="text-sm">Manage Users</h4>
              <div className="flex items-center">
                <label className="input input-sm input-bordered flex items-center gap-2 mr-3">
                  <input
                    type="text"
                    className="grow "
                    placeholder="Search by name, email, role"
                    onChange={handleSearchTerm}
                  />
                  <kbd className="kbd kbd-sm">⌘</kbd>
                  {/* <kbd className="kbd kbd-sm">K</kbd> */}
                </label>

                <button
                  onClick={handleDownloadAdminUsers}
                  className="btn btn-sm btn-outline"
                >
                  <MdFileDownload />{" "}
                </button>
              </div>
            </div>
          </div>

          <div className=" mt-4 bg-white rounded-lg">
            <table className="table">
              <thead className="bg-[#F5F5F5]">
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email Address</th>
                  <th>Role</th>
                  <th>Date Created</th>
                  <th>Actions</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody className="font-xs font-normal">
                {adminUserList.data?.data?.map((user) => (
                  <tr key={v4()} className="font-xs font-normal">
                    <th>
                      {" "}
                      <div className="avatar placeholder rounded-full">
                        <div className="w-12 bg-neutral text-neutral-content rounded-full">
                          <span>AD</span>
                        </div>
                      </div>
                    </th>
                    <th className="font-xs font-normal">{user.name}</th>
                    <th className="font-xs font-normal">{user.email}</th>
                    <th className="text-xs font-normal">{user?.role?.name}</th>
                    <th className="text-xs font-normal">
                      {new Date(user.createdAt).toUTCString().split("GMT")[0]}
                    </th>
                    <th className="text-xs font-normal">
                      {/* <button className="flex items-center gap-1">
                        <img src={UserIcon} alt="add user" />
                        <p className=" text-[#3D51A3]">Edit</p>
                      </button> */}
                      <button className="flex items-center gap-1 btn-error mt-2">
                        {/* <img src={UserIcon} alt="add user" /> */}
                        <p
                          className=" text-red-500"
                          onClick={() => handleDelete(user.id, user.name)}
                        >
                          Delete
                        </p>
                      </button>
                    </th>
                  </tr>
                ))}
                {adminUserList.isLoading && (
                  <div className="  loading loading-spinner"></div>
                )}
              </tbody>
            </table>
            <div className="flex mt-4 justify-center w-full">
              <Pagination
                page={filters.pageNumber}
                count={10}
                shape="rounded"
                onChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Users;

export type AddCardUser = {
  open: boolean;
  handleClose: () => any;
};
function AddUserCard(props: AddCardUser) {
  const { createAdmin, adminUserList } = useUserLogic();
  const { rolesList } = useRolesLogic();
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className="p-6 w-[300px]">
        <div className=" w-full mb-4 flex items-center justify-between">
          <p className="font-bold text-sm">Add New Users</p>
          <button onClick={props.handleClose}>
            <CloseSquare size="22" color="#071839" />
          </button>
        </div>

        <Formik
          initialValues={{
            fullname: "",
            email: "",
            role: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            createAdmin.mutate(
              {
                email: values.email,
                name: values.fullname,
                role_id: values.role,
              },
              {
                onSuccess: (response) => {
                  toast.dismiss();
                  toast.success(response.message);
                  adminUserList.refetch();
                  props.handleClose();
                },
                onError: (err: any) => {
                  console.log({ err });
                  toast.dismiss();
                  toast.error(
                    `Unable to create User: ` + err?.response.data.message
                  );
                },
                onSettled: () => {
                  setSubmitting(false);
                },
              }
            );
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    FullName:
                  </p>
                  <Field
                    required
                    name="fullname"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <div className="my-4">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Email:
                  </p>
                  <Field
                    required
                    name="email"
                    className="input input-bordered outline-none w-full max-w-xs"
                  />
                </label>
              </div>
              <div className=" mb-3">
                <label className="form-control w-full max-w-xs">
                  <p className="label text-xs text-[#4E5566] font-semibold">
                    Role:
                  </p>
                  <Field
                    required
                    name="role"
                    as="select"
                    className="input input-bordered outline-none w-full max-w-xs"
                  >
                    <option value="" disabled>
                      Select Role
                    </option>
                    {rolesList.data?.data.map((role) => (
                      <option key={v4()} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </Field>
                </label>
              </div>
              <div className="mx-6 mt-4">
                <button
                  className="btn btn-outlined w-full bg-[#071839ea] text-white hover:bg-[#071839] "
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Creating User" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
}
